<div class="card">
    @if (card.attn) {
        <div>{{ card.attn }}</div>
    }
    @if (card.organization) {
        <div>{{ card.organization }}</div>
    }
    @if (card.street1) {
        <div>{{ card.street1 }}</div>
    }
    @if (card.street2) {
        <div>{{ card.street2 }}</div>
    }
    @if (card.street3) {
        <div>{{ card.street3 }}</div>
    }
    @if (card.city) {
        <div>{{ card.city }}</div>
    }
    <div class="flex flex-row gap-2">
        @if (card.province) {
            <div>{{ card.province | provinceName:card.country }}</div>
        }
        @if (card.postalCode) {
            <div>{{ card.postalCode }}</div>
        }
    </div>
    @if (card.country) {
        <div>{{ card.country | countryName }}</div>
    }
    @if (card.telephone) {
        <div>{{ card.telephone }}</div>
    }
    @if (card.email) {
        <div>{{ card.email }}</div>
    }
</div>